/**
 * The CX dashboard is in limited rollout while the ticket risk scoring model is being
 * validated, so access is restricted to the CX and engineering folks reviewing it rather
 * than every employee. Unlike `canAccessLab` this applies in every environment — the
 * point is to keep the in-progress scores off the wider team's screens everywhere.
 *
 * This gate hides the UI; it is not a security boundary. The underlying svc-support
 * endpoint authorises on the `admin-user` / `employee` roles, so anyone with those roles
 * can still call the API directly. Narrow the endpoint too if that matters.
 */
export const CX_DASHBOARD_ALLOWED_EMAILS: ReadonlyArray<string> = [
  'james.beattie@luxuryescapes.com',
  'sharon.maprasert@luxuryescapes.com',
  'min.pangastur@luxuryescapes.com',
  'emily.gibney@luxuryescapes.com',
  'koren.sela@luxuryescapes.com',
  'william.ritossa@luxuryescapes.com',
  'kristine.lane@luxuryescapes.com',
  'lachlan.mellington@luxuryescapes.com',
  'shay.hamama@luxuryescapes.com',
  'vanessa.kraut@luxuryescapes.com',
  'tammie.russell@luxuryescapes.com',
  'bill.helwe@luxuryescapes.com',
  'chris.swanepoel@luxuryescapes.com',
  'lucia.marshall@luxuryescapes.com',
  'yagna.swaroop@luxuryescapes.com',
  'gabby.sexton@luxuryescapes.com',
  'ava.lawrence@luxuryescapes.com',
  'caroline.ball@luxuryescapes.com',
  'melissa.crees@luxuryescapes.com',
  'rex.demiri@luxuryescapes.com',
  'bec.gynes@luxuryescapes.com',
  'jayme.davis@luxuryescapes.com',
  'lenore.kennedy@luxuryescapes.com',
  'jamie.lane@luxuryescapes.com',
  'jack.s.comeskey@luxuryescapes.com',
  'samuel.drown@luxuryescapes.com',
  'jayden.hunter@luxuryescapes.com',
  'cassandra.boland@luxuryescapes.com',
  'natasha.klein@luxuryescapes.com',
  'imran.mahmood@luxuryescapes.com',
  'yudi.herdiansyah@luxuryescapes.com',
  'wanda.pratiwi@luxuryescapes.com',
  'eugene.moskvita@luxuryescapes.com',
  'jessica.cole@luxuryescapes.com',
];

const allowedEmails = new Set(CX_DASHBOARD_ALLOWED_EMAILS.map((email) => email.toLowerCase()));

export function canAccessCxDashboard(user: { email?: string | null } | null | undefined): boolean {
  if (!user?.email) {
    return false;
  }

  return allowedEmails.has(user.email.trim().toLowerCase());
}
